// extracted by mini-css-extract-plugin
export default {"dashboard__h2":"Dashboard_dashboard__h2__zcKVq","dashboard__section":"Dashboard_dashboard__section__RPxxA"};